import React from 'react';
import { useAssessment } from '@/contexts/AssessmentContext';
import MatrixVisualization from '../MatrixVisualization';
import RankedList from '../RankedList';
import AssessmentActionButtons from './AssessmentActionButtons';

const AssessmentResultsStep = () => {
  const { weights, scoredOpportunities } = useAssessment();

  return (
    <div className="space-y-8">
      <div className="mb-6">
        <AssessmentActionButtons 
          weights={weights}
          scoredOpportunities={scoredOpportunities}
          isEditing={true}
        />
      </div>
      <MatrixVisualization />
      <RankedList />
    </div>
  );
};

export default AssessmentResultsStep;